import React, { useState } from 'react'
import styles from './styles.module.scss'
import Link from 'next/link'
import { authorRoute } from 'src/consts'
import AuthorItem from '../AuthorItem'
import { TOO_MANY_REQUESTS } from 'http-status'

export type ListProps = {
  data?: object
}

export const AuthorList = ({ data }: ListProps) => {
  // Flatten the data into a single array
  const flatData = Object.values(data).flat()

  return (
    <div className={styles.container}>
      <div className={styles.items}>
        {flatData.map((author, index) => (
          <div key={index} className={styles.item}>
            <AuthorItem author={author} alwaysShowBio={false} isLink={true} />
          </div>
        ))}
      </div>
    </div>
  )
}
